var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCombined2 = function SvgCombined2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "8094EDC1-99B2-484F-8AF2-2E9BDE6B31D7")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Versicherungsausweis-04",
    transform: "translate(-34.000000, -430.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Card-Antwort-2",
    transform: "translate(16.000000, 412.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3686857,8.98865612 C13.8223456,8.53502483 14.576834,8.53526471 15.0109982,8.98919191 C15.4643623,9.44311911 15.4641226,10.1788406 15.0104627,10.6324719 L15.0104627,10.6324719 L13.6421355,11.9995895 L15.010153,13.3676884 C15.4314086,13.7884475 15.461705,14.4529074 15.1008951,14.9091206 L15.0106885,15.0104984 C14.5573243,15.4644256 13.822036,15.4646655 13.368376,15.0110342 L13.368376,15.0110342 L12.0001355,13.6425895 L10.631624,15.0110342 C10.2103683,15.4322633 9.54628002,15.4621442 9.09057078,15.1008243 L8.98931153,15.0104984 C8.53594734,14.5565712 8.53618708,13.8208497 8.989847,13.3676884 L8.989847,13.3676884 L10.3571355,11.9995895 L8.98953733,10.6324719 C8.56828168,10.2112429 8.53798528,9.54678295 8.89879523,9.09056971 L8.98900185,8.98919191 C9.44236604,8.53526471 10.1776544,8.53502483 10.6313143,8.98865612 L10.6313143,8.98865612 L12.0001355,10.3565895 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCombined2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Combined2.e2b6394c.svg";
export { ForwardRef as ReactComponent };